import { cn } from '@verlo/shared/lib/utils';
import { usePageTitle } from '../Layout';

/**
 * Every back-office page starts with this (Back Office Review, wave A). The title is
 * published to the top line — the third step of the path, beside the area — so the body
 * opens with the one line that says what the page decides (not "Manage your …"), the
 * actions on the right, and tabs below when the page has views. One component, so
 * sixty-four pages open the same way.
 *
 *   <PageHeader title="Stock levels" purpose="What's below par, and what to order today."
 *               actions={<Button>Add item</Button>} />
 */
const PageHeader = ({ eyebrow, title, purpose, actions, tabs, className, testId }) => {
  usePageTitle(title);
  return (
    <header className={cn('mb-5', className)} data-testid={testId}>
      <div className="flex min-h-[36px] flex-wrap items-center justify-between gap-x-6 gap-y-3">
        <div className="min-w-0">
          {eyebrow && <div className="mb-1 font-heading text-[11px] font-bold uppercase tracking-[0.08em] text-verlo-hover">{eyebrow}</div>}
          {purpose && <p className="max-w-2xl text-[14px] text-ink-soft">{purpose}</p>}
        </div>
        {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
      {tabs && <div className="mt-4">{tabs}</div>}
    </header>
  );
};

export default PageHeader;
